import mainLayoutAppearance from './mainLayoutAppearance';
import dimensions from './dimensions';
import pagination from './pagination';
import blockingDialogs from './blockingDialogs';
import featureFlags from './featureFlags';
import configParameters from './configParameters';
import referrals from './referrals';

const commonModules = {
  mainLayoutAppearance,
  dimensions,
  pagination,
  blockingDialogs,
  featureFlags,
  configParameters,
  referrals
};

export default commonModules;

export * from './mainLayoutAppearance';
export * from './dimensions';
export * from './pagination';
export * from './blockingDialogs';
export * from './featureFlags';
export * from './configParameters';
export * from './referrals';
